import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  // public urlServidor=`http://dviobtest:8080/ApiportalDavivienda/servicios/frontend`;// DESARROLLO
  public urlServidor=`https://www.daviviendaintl.com/ApiportalDavivienda/servicios/frontend`;// PRODUCCION


  // public urlServidor=`https://12.170.6.90:8443/ApiportalDavivienda/servicios/frontend`;//PROD
  // public urlServidor=`https:/10.1.1.56:8443/ApiportalDavivienda/servicios/frontend`;//PROD
  //public urlServidor=`https://apipublica.daviviendaintl.com/ApiportalDavivienda/servicios/frontend`;//PROD
  
// public urlServidor=`http://sv4104wap:8080/ApiportalDavivienda/API/frontend`;//desa local
  // public urlServidor=`https://12.170.6.90:8443/Api-portalDavivienda/API/frontend`;//desa



//  public urlServidor=`https://apipublica.daviviendaintl.com:8443/ApiportalDavivienda/servicios/frontend`;//PROD


  

  constructor(private http:HttpClient) { }

  public postMetodo(microServicio, data):Observable<any>{
    let url=`${this.urlServidor}${microServicio}`;
    // let headers={headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*','Referrer-Policy': 'no-referrer',"Access-Control-Allow-Methods" : "GET, POST, OPTIONS, PUT, DELETE" })};
    let body=JSON.stringify(data);
    return this.http.post(url, body);
  }

  public postMetodoOnBase(microServicio, data):Observable<any>{
    let url=`${this.urlServidor}${microServicio}`;
    // let url=`${'http://sv4077lap.daviviendasv.com:8004/OperacionesGestor/webapp'}${microServicio}`;
    let body=JSON.stringify(data);
    //let headers={headers: new HttpHeaders({ 'Content-Type': 'application/json' })};
    return this.http.post(url, body);
  }


}
